import Icon from 'veui/components/Icon'
import { IconArrowUp } from 'dls-icons-vue'

Icon.register('arrow-up', IconArrowUp)
